'use client';

import { useState, useCallback } from 'react';

// Define the return type of the hook for better TypeScript support
type UseDisclosureReturnType = {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  onToggle: () => void;
};

// The hook itself
export const useDisclosure = (
  defaultIsOpen = false,
): UseDisclosureReturnType => {
  const [isOpen, setIsOpen] = useState(defaultIsOpen);

  // Function to open the element
  const onOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  // Function to close the element
  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  // Function to toggle the open state
  const onToggle = useCallback(() => {
    setIsOpen((prevState) => !prevState);
  }, []);

  return { isOpen, onOpen, onClose, onToggle };
};
